import React, {
    useEffect,
    useState,
    useRef,
    useCallback,
    useMemo,
  } from "react";
  import axios from "axios";
  
  import { useParams, Link } from "react-router-dom";
  import Select from "react-select";
  import config from "../../../config/config";
  import Loader from "../../../components/Loader/Loader";
  import Sidebar from "../../Dashboard/Sidebar/Sidebar";
  import jsPDF from "jspdf";
  import JsBarcode from "jsbarcode";
  //import { Field, Form, Formik } from "formik";
  
  import * as XLSX from "xlsx";
  
  import moment from "moment";
  import ReportDate from "../../../components/Reports/ReportDate";
  
  import { AgGridReact } from "ag-grid-react";
  import "ag-grid-enterprise";
  import "ag-grid-community/styles/ag-grid.css";
  import "ag-grid-community/styles/ag-theme-alpine.css";
  import "../../../assets/css/customersummary.css";
  import "jspdf-autotable";
  import Moment from "moment";
  
  //--------Material React Table------//
  import { MaterialReactTable } from "material-react-table";
  import { Box, Button } from "@mui/material";
  import FileDownloadIcon from "@mui/icons-material/FileDownload";
  import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
  
  const currentDate = new Date();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
  const hours = currentDate.getUTCHours();
  const minutes = currentDate.getUTCMinutes();
  
  const DeletedSalesReport = (props) => {
  
    const locationid = localStorage.getItem("Location")
    const gridRef = useRef();
    const token = localStorage.getItem("Token");
    const [responseData, setResponseData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalSum, setTotalSum] = useState(0);
    const [totalbalance, setTotalBalance] = useState(0);
  
    const [startdate, setStartDate] = useState("");
    const [enddate, setEndDate] = useState("");
    const [selectedDate, setSelectedDate] = useState([]);
    const [selectReport, setSelectReport] = useState(7);
    const [TierList, setTierList] =
      useState([]);
    // const [saletype, setSaletype] = useState([]);
    const [salesTypeValue, setSalesTypeValue] = useState();
    const [salesTypeID, setSalesTypeID] = useState(0);
    const [saletype, setSaletype] = useState([]);
    const [tierid, settierid] = useState(0);
    const [customerDropdown, setcustomerDropdown] = useState([]);
    const [customerid, setcustomerid] = useState(0);
  
    //----------------Server-Side------------------//
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
  
    //table state
    const [columnFilters, setColumnFilters] = useState([]);
    console.log(columnFilters,"sdjkfgb");
    const [globalFilter, setGlobalFilter] = useState("");
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
      pageIndex: 0,
      pageSize: 25,
    });

    const [totalData, setTotalData] = useState({
      TotalSum: 0,
      SubTotalSum: 0,
      TaxSum: 0,
      CostOfGoodsSoldSum: 0,
      ProfitSum: 0,
    });
  
    const ITEMS_PER_PAGE = 10;
  
    const barcodeRefs = useRef([]);
    let index = 0;
    const [data, setData] = useState({
      inputValue: "",
      width: 1,
      height: 20,
      fontSize: 15,
      zeroFill: 10,
    });
  
    //Function to generate barcode
    const generateBarcodes = () => {
      barcodeRefs.current.forEach((barcodeRef, index) => {
        console.log("barcodeRefs", barcodeRefs);
        var g = document.getElementsByTagName(barcodeRef);
        const barcodeValue = paramObject.id;
        console.log("barcodeValue", barcodeValue);
        const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
        JsBarcode(barcodeRef, paddedBarcodeValue, {
          width: data.width,
          height: data.height,
          fontSize: data.fontSize,
          displayValue: true,
          fontoptions: "bold",
          textAlign: "center",
          font: "monospace",
          textPosition: "bottom",
          textMargin: 2,
          margin: 10,
          marginTop: undefined,
          marginBottom: undefined,
          marginLeft: undefined,
          marginRight: undefined,
          format: "CODE128",
          valid: () => true,
          background: "#ffffff",
          lineColor: "#000000",
          padding: data.zeroFill,
        });
      });
    };
  
    //Function for download
  
    const handleDropdownChange = (event) => {
      setSelectReport(event?.value);
    };
  
    //Function for lookup receipt
    const paramObject = useParams();
  
    const handleChangeTier = (event, index) => {
      console.log(event?.label, event?.value, event?.id, "handleChangeTier");
      settierid(event?.id);
  
    };

    const handleChangeCustomer = (event) => {
      console.log(event, "handleChangeCustomer")
      setcustomerid(event?.value);
    };
  
    let salesTypeDropdownOption = [];
    const SalesTypeDropdown = saletype.map((u, i) => {
      salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
    });
    useEffect(() => {
      const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
      console.log(
        JSON.stringify(columnFilters) + " columnFilters | ",
        globalFilter + " globalFilter | ",
        pagination.pageIndex + " pagination.pageIndex | ",
        pagination.pageSize + " pagination.pageSize | ",
        columnIndex,
        sorting[0]?.id,
        sorting[0]?.desc === undefined
          ? "desc"
          : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
        startdate + " startdate | ",
        enddate + " enddate",
        tierid + " tierid",
        customerid + " customerid",
        salesTypeID + " saletype",
        locationid + " locationid",
  
        "api Call payload"
      );
  
      const FilterColumnText = {};
      FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
        return { columnname: el.id, value: el.value, id: index + 1 };
      });
  
      let FilterColumnSearchText = JSON.stringify(FilterColumnText);
  
      axios
        .get(
          `${
            config.reportsBaseUrl
          }/reports/deletedsales?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
            sorting[0]?.desc === undefined
              ? "desc"
              : sorting[0]?.desc === true
              ? "desc"
              : "asc"
          }&ordercolumn=${columnIndex}&pagesize=${
            pagination.pageSize
          }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
            globalFilter === undefined ? "" : globalFilter
          }&startdate=${startdate}&enddate=${enddate}&customerid=${customerid}&saletype=${salesTypeID}&locationid=${locationid}&tierid=${tierid}
          `,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
  
        .then((res) => {
          console.log("res======>", res);
          console.log(res.data.ResponseData, "res======>");
          if (res.data.ResponseCode === "SUCCESS") {
            setResponseData(res.data.ResponseData);
            setData(res.data.ResponseData);
            if (res.data.ResponseData.length > 0) {
              setRowCount(res.data.ResponseData[0].TotalRecord);
              setTotalData({
                ...totalData,
                TotalSum: res.data.ResponseData[0].TotalSum,
                SubTotalSum: res.data.ResponseData[0].SubTotalSum,
                TaxSum: res.data.ResponseData[0].TaxSum,
                ProfitSum: res.data.ResponseData[0].ProfitSum,
              });
            }else {
              setRowCount(0);
              setTotalData({
                ...totalData,
                TotalSum: 0,
                SubTotalSum: 0,
                TaxSum: 0,
                CostOfGoodsSoldSum: 0,
                ProfitSum: 0,
              });
            }
          }
          setLoading(false);
        })
        .catch((err) => {
          setIsError(true);
          console.log(err);
          setLoading(false);
          return;
        });
  
      setIsError(false);
      setIsLoading(false);
      setIsRefetching(false);
    }, [
      columnFilters,
      globalFilter,
      pagination.pageIndex,
      pagination.pageSize,
      sorting,
      startdate,
      enddate,
      locationid,
      tierid,
      customerid,
      salesTypeID
    ]);
  
    console.log(responseData, "responseData168");
    useEffect(() => {
      generateBarcodes();
      console.log("barcodeRefs", barcodeRefs);
      setLoading(true);
  
      axios
        .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        })
        .then((res) => {
          console.log("setSelectedDate======>", res);
          setSelectedDate(res.data.ResponseData);
          return res;
        });
  
      axios
        .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        })
        .then((response) => {
          // console.log(response.data?.ResponseData, "response of tire list")
          setTierList(response.data?.ResponseData);
        })
        .catch((error) => {
          console.log(error.message);
        });

        axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log("employee", res);
        setcustomerDropdown(res.data.ResponseData);
        // setLoading(false);

        return res;
      });
  
      axios
        .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        })
        .then((response) => {
          setSaletype(response.data.ResponseData);
          console.log(response.data.ResponseData, "===> setSaletype");
        })
        .catch((error) => {
          console.log(error);
        });
    }, []);
  
    console.log(TierList, "TierList");
    console.log(customerDropdown, "customerDropdown");

    //console.log(saletype, "saletype");
   
    // to calculate the total
    const calculateTotalSum = () => {
      const sum = responseData.reduce((total, report) => {
        const reportTotal = Number(report.Amount);
  
        if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
          return total + reportTotal;
        } else {
          return total;
        }
      }, 0);
  
      setTotalSum(sum);
    };
  
    // to calculate the total
    const calculateTotalBalance = () => {
      const sum = responseData.reduce((total, report) => {
        const reportTotal = Number(report.Balance);
  
        if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
          return total + reportTotal;
        } else {
          return total;
        }
      }, 0);
  
      setTotalBalance(sum);
    };
  
    useEffect(() => {
      calculateTotalSum();
      calculateTotalBalance();
    }, [responseData]);
  
    const callback = (payload, enddate2) => {
      console.log("stardate =>", payload);
      setStartDate(payload);
      setEndDate(enddate2);
  
      console.log("enddate =>", enddate2);
    };
  
    const columnTypes = useMemo(() => {
      return {
        number: {
          editable: true,
          // editing works with strings, need to change string to number
          valueParser: (params) => {
            return parseInt(params.newValue);
          },
          aggFunc: "sum",
        },
      };
    }, []);
  
    const columns = useMemo(() => [
      {
        header: "Sale Id",
        accessorKey: "SaleId",
        size:"110",
         filterFn : "contains",
      },
      {
        header: "Location",
        accessorKey: "Location",
        size:"110",
         filterFn : "contains",
      },
      {
        header: "Date",
        accessorKey: "Date",
        size:"110",
         filterFn : "contains",
        Cell: ({ row }) => moment(row.original.Date).format("YYYY-MM-DD") === "Invalid date" ? "": moment(row.original.Date).format("YYYY-MM-DD"),
      },
      // {
      //   header: "Register",
      //   accessorKey: "Register",
      // },
      {
        header: "Items Purchased",
        accessorKey: "ItemPurchased",
         filterFn : "contains",
      },
      {
        header: "Deleted By",
        accessorKey: "DeletedBy",
         filterFn : "contains",
      },
      {
        header: "Sold By",
        accessorKey: "SoldBy",
         filterFn : "contains",
      },
      {
        header: "Sold To",
        accessorKey: "SoldTo",
         filterFn : "contains",
      },
      {
        header: "Subtotal",
        accessorKey: "SubTotal",
        enableSorting : false,
        size:"110",
         filterFn : "contains",
      },
      {
        header: "Total",
        accessorKey: "Total",
        enableSorting : false,
        size:"110",
         filterFn : "contains",
      },
      {
        header: "Tax",
        accessorKey: "Tax",
        size:"110",
         filterFn : "contains",
      },
      {
        header: "Profit",
        accessorKey: "Profit",
        size:"110",
         filterFn : "contains",
      },
      {
        header: "Payment Type",
        accessorKey: "PaymentType",
        size:"110",
         filterFn : "contains",
      },
      {
        header: "Comments",
        accessorKey: "Comments",
        size:"120",
         filterFn : "contains",
      },
    ]);
  
    const handleExportRows = (rows) => {
      console.log(
        rows.map((row) => row.original),
        "selected row"
      );
      // csvExporter.generateCsv(rows.map((row) => row.original));
  
      const workbook = XLSX.utils.book_new();
      // Convert the data to a worksheet
      const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      // Save the workbook as an Excel file
      XLSX.writeFile(workbook, `DeletedSalesReport_.xlsx`);
    };
  
    const aggFuncs = useMemo(() => {
      return {
        Amount: (params) => {
          console.log(params, "params");
          let sum = 0;
          params.data?.Amount.forEach((value) => (sum += Number(value)));
          return sum;
        },
      };
    }, []);
  
    const defaultColDef = {
      sortable: true,
    };
  
    const autoGroupColumnDef = {
      comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
        var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
        return res;
      },
      field: "athlete",
      sort: "asc",
    };
  
    const handleChangeSalesType = (event) => {
      console.log(event, "handleChangeSalesType")
      setSalesTypeValue(event);
      setSalesTypeID(event?.value);
    };
  
    const totalFooterRow = {
      Customername: "Total",
      Amount: totalSum,
      Balance: totalbalance,
    };
  
    const augmentedData = [...responseData, totalFooterRow];
  
    const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);
  
    const onBtExport = () => {
      const workbook = XLSX.utils.book_new();
  
      // Convert the data to a worksheet
      const worksheet = XLSX.utils.json_to_sheet(responseData);
  
      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      // Save the workbook as an Excel file
      XLSX.writeFile(workbook, `DeletedSalesReport_.xlsx`);
    };
  
    const downloadPDF = (rows, field, visibleColumns) => {
      console.log("columnsFiled=>", visibleColumns);
  
      let newData = [];
      if (field === "selectedrow") {
        newData = rows.map((row) => row.original);
      } else if (field === "alldata") {
        newData = responseData.map((el) => {
          return {
            ...el,
            OpenBalance:
              el.OpenBalance == null
                ? ""
                : el.OpenBalance === "0.00"
                ? ""
                : el.OpenBalance,
            ModifiedBy: el.ModifiedBy == null ? "" : el.ModifiedBy,
            DeliveryAddress: el.DeliveryAddress == null ? "" : el.DeliveryAddress,
          };
        });
      }
  
      console.log(newData, "newData");
  
      //console.log(handleChangeSalesType, "handleChangeSalesType");
  
      var doc = new jsPDF("l", "pt", "a3");
  
      // Add the header
      let headerElement = document.querySelector("#header");
      let clonedHeader = headerElement.cloneNode(true);
      clonedHeader.style.fontSize = `10px`;
      clonedHeader.style.width = "560px";
      clonedHeader.style.marginLeft = "15rem";
  
      let content = "";
      let startIndex = 1;
      let endIndex = 15;
  
      for (var i = 1; i <= Math.ceil(newData.length / 15); i++) {
        if (i == 1) {
          clonedHeader.style.marginTop = "2rem";
        }
        if (i > 1 && i < Math.ceil(newData.length / 15)) {
          clonedHeader.style.marginTop = "19rem";
        }
  
        if (i == Math.ceil(newData.length / 15)) {
          clonedHeader.style.marginTop = "7rem";
        }
        // Printing header
        content += " " + clonedHeader.outerHTML;
  
        // Printing table body
        content +=
          '<table style="font-size: 8px; margin-left: 2rem; margin-top: 2rem;  width: 1140px; border: 1px solid #f5f5f5">';
        content += "<thead><tr style='margin-bottom: 5px'>";
  
        content += '<th style="padding: 7px;" className="p-regular">No</th>';
        for (var j = 0; j <= visibleColumns.length; j++) {
          if (j > 0) {
            var columnHeaderData = visibleColumns[j];
            if (columnHeaderData != undefined) {
              console.log("columnHeaderData", columnHeaderData);
              content +=
                '<th style="padding: 7px;" className="p-regular">' +
                columnHeaderData.id +
                "</th>";
            }
          }
        }
  
        content += "</tr></thead>";
        content += "<tbody>";
  
        // Loop for printing items based on endIndex
        for (let index = startIndex; index <= endIndex; index++) {
          if (index <= newData.length) {
            content +=
              "<tr>" +
              '<td style="font-size: 7px; padding: 7px;">' +
              index +
              "</td>";
  
            for (var j = 0; j <= visibleColumns.length; j++) {
              if (j > 0) {
                var columnHeaderData = visibleColumns[j];
                // console.log(
                //   "Date Parse= >",
                //   newData[index - 1][columnHeaderData.id]
                // );
                if (columnHeaderData != undefined) {
                  content +=
                    '<td style="font-size: 7px; padding: 7px;">' +
                    (moment(newData[index - 1][columnHeaderData?.id]).isValid()
                      ? moment(newData[index - 1][columnHeaderData?.id]).format(
                          "YYYY-MM-DD"
                        )
                      : newData[index - 1][columnHeaderData?.id]) +
                    "</td>";
                }
              }
            }
  
            content += "</tr>";
          }
  
          if (index % 15 == 0) {
            startIndex = startIndex + 15;
            endIndex = endIndex + 15;
            break;
          }
        }
  
        content += "</tbody>";
        content += "</table>";
  
        content +=
          '<div style="text-align: center; width: 560px;margin-left: 220px">' +
          '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
          i +
          "</p>" +
          "</div>";
      }
  
      // Printing page
      doc.html(content, {
        callback: function (pdf) {
          pdf.save("Sales_By_Categories.pdf");
          setLoading(false);
        },
      });
    };
  
    let reportdropdown = [];
    const data2 = selectedDate.map(
      (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
    );

    let dashStyle = {
      // width: "280px",
      background: "#fff",
      marginTop: "10px",
      borderRadius: "6px",
      padding: "20px",
      border: "1px solid #E8EBED",
    };
  
    console.log(responseData, "responseData941");
    return (
      <>
        <Loader loading={loading} />
        <Sidebar />
        <div className="page-wrapper cardhead">
          <div className="content container-fluid">
            <div
              className="page-header"
              style={{
                position: "fixed",
                top: "2px",
                zIndex: "999",
              }}
            >
              <div className="row breadcrumb-position">
                {/* <h3 className="page-title">Customer Balance Detail</h3> */}
                <ul className="breadcrumb">
                  <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/reports">Report</Link>
                  </li>
                  <li className="breadcrumb-item active">Deleted Sales</li>
                </ul>
              </div>
            </div>
  
            <div className="row">
              <div className="col-sm-3 z-4">
                <label className="col-form-label col-md-5 form-label p-lg-medium">
                  Tier Name
                </label>
                <div className="row">
                  <div className="col-md-11 z-3">
                    <Select
                      options={TierList.map((tire) => ({
                        label: tire.Name,
                        value: tire.Code,
                        id: tire.ID,
                      }))}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      onChange={(e, index) => handleChangeTier(e, index)}
                      className="custom-select-search"
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-3">
              <label className="col-form-label col-md-3">Customer</label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    options={customerDropdown.map((customer) => ({
                      label: customer.CompanyName + " ("+ customer.FirstName + customer.LastName + ")",
                      value: customer.Id,
                    }))}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(e, index) => handleChangeCustomer(e, index)}
                    className="custom-select-search"
                  />
                </div>
              </div>
            </div>
              <div className="col-sm-3">
                <label className="col-form-label col-md-5 form-label p-lg-medium">
                  Sale Type
                </label>
                <div className="row">
                  <div className="col-md-11 z-3">
                  <Select
                      defaultValue={salesTypeValue}
                      onChange={(event) => {
                        handleChangeSalesType(event);
                      }}
                      options={salesTypeDropdownOption}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      className="custom-search-select mt-1"
                    />
                  </div>
                </div>
              </div>
              </div>
            <div className="row">
                <div className="col-sm-3">
                  <label className="col-form-label col-md-5 form-label p-lg-medium">
                    Report period
                  </label>
                  <div className="row">
                    <div className="col-md-11 z-3">
                      <Select
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        options={reportdropdown}
                        // defaultValue={selectReport}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        name="Reportperiod"
                        id="Reportperiod"
                        value={reportdropdown.find((e) => e.value === selectReport)}
                        onChange={(event) => {
                          handleDropdownChange(event);
                        }}
                        className="custom-search-select"
                      ></Select>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="row">
                    <ReportDate
                      callback={callback}
                      selectReport={selectReport}
                      showhidecomponent={
                        selectReport == 2 ||
                        selectReport == 3 ||
                        selectReport == 4 ||
                        selectReport == 5 ||
                        selectReport == 6 ||
                        selectReport == 7 ||
                        selectReport == 8 ||
                        selectReport == 9 ||
                        selectReport == 10 ||
                        selectReport == 11 ||
                        selectReport == 12 ||
                        selectReport == 13 ||
                        selectReport == 14 ||
                        selectReport == 15 ||
                        selectReport == 16 ||
                        selectReport == 17 ||
                        selectReport == 18 ||
                        selectReport == 19 ||
                        selectReport == 20 ||
                        selectReport == 21 ||
                        selectReport == 22 ||
                        selectReport == 23 ||
                        selectReport == 24 ||
                        selectReport == 25 ||
                        selectReport == 26 ||
                        selectReport == 27 ||
                        selectReport == 28 ||
                        selectReport == 29 ||
                        selectReport == 30 ||
                        selectReport == 31
                          ? true
                          : false
                      }
                    />
                  </div>
                </div>
            </div>

            <div
            className="row"
            style={{
              display: "grid",
              gap: "1rem",
              // gridTemplateColumns: "repeat(5,1fr)"
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            }}
          >
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">${totalData.SubTotalSum}</p>
                  <div className="d-flex">
                    <p className="p-medium">Subtotal</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">${totalData.TotalSum}</p>
                  <div className="d-flex">
                    <p className="p-medium">Total</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">${totalData.TaxSum}</p>
                  <div className="d-flex">
                    <p className="p-medium">Tax</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">${totalData.ProfitSum}</p>
                  <div className="d-flex">
                    <p className="p-medium">Profit</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
            {/* Receipt */}
  
            <div className="card mt-3">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center " id="header">
                    <h6 class="p">SonarPos</h6>
                    <p className="fw-bold p-regular">Deleted Sales</p>
                    <div className="row mb-2">
                      {/* <h6> Date: {new Date().toLocaleDateString()}</h6>
                        <p >
                          Date: {startdate} - {enddate}
                        </p> */}
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : startdate + " - " + enddate}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
  
                <div className="table-responsive">
                  <div className="table mt-3"></div>
  
                  <div>
                    {/* <MaterialReactTable
                      muiTableContainerProps={{
                        sx: { maxHeight: "fit-content" },
                      }}
                      columns={columns}
                      data={data}
                      enableColumnResizing
                      enableGrouping
                      enableColumnFilters
                      shortDescFirst={true}
                      enableStickyHeader
                      enableStickyFooter
                      enableRowSelection
                      enableColumnOrdering
                      sortDescFirst
                      muiTableBodyProps={{
                        sx: () => ({
                          "& tr:nth-of-type(even)": {
                            backgroundColor:
                              "var(--datatable-row-background-color)",
                            //'rgb(237 237 233 / 63%)'
                          },
                          "& td": {
                            borderRight:
                              "1px solid var(--datatable-row-background-hover-color)",
                            lineHeight: "16px",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          },
  
                          "& tr": {
                            lineHeight: "16px",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          },
                        }),
                      }}
                      muiTableHeadCellProps={{
                        sx: (theme) => ({
                          background: "var(--datatable-row-background-color)", //'#e9e9e9',
                          borderRight:
                            "1px solid var(--datatable-row-background-hover-color)",
                          lineHeight: "16px",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      muiToolbarAlertBannerProps={
                        {
                          isError: () => ({
                            color: "error",
                            children: "Error loading data",
                          }),
                          sx: (theme) => ({
                            background: "var(--datatable-row-background-color)", //'#e9e9e9',
                            lineHeight: "16px",
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          }),
                        }
                      }
                      muiSelectCheckboxProps={{
                        sx: (theme) => ({
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--prinary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      muiSelectAllCheckboxProps={{
                        sx: (theme) => ({
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--prinary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      initialState={{
                        density: "compact",
                        expanded: true, //expand all groups by default
                        // grouping: ["CustomerName"], //an array of columns to group by by default (can be multiple)
                        pagination: { pageIndex: 0, pageSize: 25 },
                        sorting: [{ id: "state", desc: false }], //sort by state by default
                      }}
                      // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                      // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                      muiPaginationProps={{
                        rowsPerPageOptions: [25, 50, 100, 300, 500],
                      }}
                      manualFiltering
                      manualPagination
                      manualSorting
                      onColumnFiltersChange={setColumnFilters}
                      onGlobalFilterChange={setGlobalFilter}
                      onPaginationChange={setPagination}
                      onSortingChange={setSorting}
                      rowCount={rowCount}
                      state={{
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                      }}
                      renderTopToolbarCustomActions={({ table }) => (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "0.5rem",
                            p: "0.5rem",
                            flexWrap: "wrap",
                          }}
                        >
                          <Button
                            // size="small"
                            class="btn btn-sm btn-secondary"
                            style={{ display: "flex" }}
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={onBtExport}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export All In Excel
                          </Button>
                          <Button
                            // size="small"
                            class="btn btn-sm btn-secondary"
                            style={{ display: "flex" }}
                            disabled={
                              !table.getIsSomeRowsSelected() &&
                              !table.getIsAllRowsSelected()
                            }
                            //only export selected rows
                            onClick={() =>
                              handleExportRows(table.getSelectedRowModel().rows)
                            }
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export Selected Rows in Excel
                          </Button>
  
                          <Button
                            // size="small"
                            class="btn btn-sm btn-secondary"
                            style={{ display: "flex" }}
                            color="primary"
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={() =>
                              downloadPDF(
                                "",
                                "alldata",
                                table.getVisibleFlatColumns()
                              )
                            }
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export All In Pdf
                          </Button>
                          <Button
                            // size="small"
                            class="btn btn-sm btn-secondary"
                            style={{ display: "flex" }}
                            disabled={
                              !table.getIsSomeRowsSelected() &&
                              !table.getIsAllRowsSelected()
                            }
                            //only export selected rows
                            onClick={() =>
                              downloadPDF(
                                table.getSelectedRowModel().rows,
                                "selectedrow",
                                table.getVisibleFlatColumns()
                              )
                            }
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export Selected Rows in Pdf
                          </Button>
                        </Box>
                      )}
                    /> */}
                    <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Deleted Sale's"
                    columns={columns}
                    data={data}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={[]}
                    columnsVisibility={{}}
                  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  
  export default DeletedSalesReport;
  